module.exports = __webpack_public_path__ + "static/media/hospital.760fc5e6.jpg";